import React from 'react'
import cn from 'classnames'
import { Typography } from '@grammarly/badger-ui'
import { TypeIconListItemProps, IconListFieldSize } from '../../../lib/types'
import { ImageAsset } from '../../asset/image'
import styles from './icon-list-item.module.scss'

const { C4 } = Typography

export const IconListItem: React.FC<TypeIconListItemProps> = ({ structure, iconSize, showAltTextUnderIcon }) => {
  const iconSizeClasses = {
    [IconListFieldSize.Large]: styles.large,
    [IconListFieldSize.Small]: '',
  }

  const {
    fields: { title, ...otherFields },
  } = structure

  // When we want to show alt text under icons, replace the alt text title from image asset with empty text
  // This ensures that the screen reader does not read the image alt text twice and the image asset is decorative with text under it.
  const titleForImage = showAltTextUnderIcon ? '' : title
  const imageStructure = { ...structure, fields: { title: titleForImage, ...otherFields } }

  return (
    <div className={styles.iconListItem}>
      <div className={cn(styles.iconContainer, iconSizeClasses[iconSize])}>
        <ImageAsset structure={imageStructure} className={styles.icon} />
      </div>
      {!!showAltTextUnderIcon && (
        <C4 as="div" className={styles.iconText}>
          {title}
        </C4>
      )}
    </div>
  )
}
